<template>
    <slot></slot>
    <span class="underline animate" :style="underlineStyle">
        <span
            :style="outlineStyle"
            :class="`${isGradientUnderline ? 'gradient-bottom-line' : 'outline-inside'}`"
        ></span>
    </span>
</template>

<style src="./TabsAnimatedHeader.scss"></style>

<script src="./TabsAnimatedHeader.ts"></script>
